<div class="container-fluid tp-box" [@flipState]="flip">
	<!-- Back side - Detailed view -->
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="col-12">
			<div class="mp-wrap" [ngStyle]="themeVars">
				<div class="mp-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
					<i class="material-icons">monetization_on</i>
				</div>
				<div class="mp-header">
					<div class="mp-title-group">
						<span class="mp-title">{{ title }}</span>
					</div>
				</div>
				<div class="mp-body" *ngIf="!loading && !error && metalPrices.length > 0">
					<div class="metal-prices-detail">
						<div class="metals-table-container" *ngFor="let category of getCategoryOrder()">
							<div *ngIf="groupedMetals[category] && groupedMetals[category].length > 0 && splitColumns[category] && splitColumns[category].length > 0">
								<h5 class="category-header">{{ category }}</h5>
								<div class="row">
									<div class="col-md-6" *ngFor="let column of splitColumns[category]; trackBy: trackByIndex">
										<table class="table table-striped table-hover metals-table">
											<thead>
												<tr>
													<th>Metal</th>
													<th class="text-right">Price</th>
													<th class="text-center">Unit</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let price of column">
													<td>
														<i class="material-icons metal-icon">{{ getMetalIcon(price.metal) }}</i>
														{{ price.metal }}
													</td>
													<td class="text-right price-cell">
														<strong>{{ formatPrice(price.price) }}</strong>
													</td>
													<td class="text-center">{{ price.unit }}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						<div class="last-updated" *ngIf="lastUpdated">
							<p class="text-muted">
								<i class="material-icons">access_time</i>
								Last updated: {{ lastUpdated | date:'short' }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Front side - Summary view -->
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12">
			<div class="mp-wrap" [ngStyle]="themeVars">
				<div class="mp-icon-badge">
					<i class="material-icons">monetization_on</i>
				</div>
				<div class="mp-header">
					<div class="mp-title-group">
						<span class="mp-title">{{ title }}</span>
						<span class="mp-subtitle" *ngIf="!loading && !error && metalPrices.length > 0">{{ metalPrices.length }} Metals</span>
					</div>
					<div class="mp-actions">
						<button class="mp-icon-btn" type="button" (click)="refreshPrices()" matTooltip="Refresh" [matTooltipPosition]="'below'">
							<i class="material-icons">refresh</i>
						</button>
					</div>
				</div>
				<div class="mp-body" *ngIf="loading">
					<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
				</div>
				<div class="mp-body" *ngIf="!loading && !error && metalPrices.length > 0">
					<div class="metal-prices-summary">
						<div class="metals-table-container" *ngFor="let category of getCategoryOrder()">
							<div *ngIf="groupedMetals[category] && groupedMetals[category].length > 0 && splitColumns[category] && splitColumns[category].length > 0">
								<h6 class="category-header-small">{{ category }}</h6>
								<div class="row">
									<div class="col-md-6" *ngFor="let column of splitColumns[category]; trackBy: trackByIndex">
										<table class="table table-sm table-striped metals-table-small">
											<tbody>
												<tr *ngFor="let price of column">
													<td class="metal-name">{{ price.metal }}</td>
													<td class="text-right price-cell-small">
														<strong>{{ formatPrice(price.price) }}</strong>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mp-body" *ngIf="error && !loading">
					<div class="error-message">
						<i class="material-icons">error_outline</i>
						<p>{{ error }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
